import React from 'react'
import { Paragraph } from 'theme-ui'
import { FAQItem } from 'components/FrequentlyAskedQuestions'
import { CONTROLDText } from 'ui/CONTROLD'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `Which platforms and devices can I integrate with ${CONTROLDText}?`,
    answer: (
      <Paragraph>
        {CONTROLDText} supports a wide range of platforms, including desktop computers, mobile
        devices, and even certain router firmware, to help you easily manage your internet settings.
        Whether you&apos;re running Windows, macOS, iOS, or Android, the integration process
        typically involves updating your DNS configuration. By offering broad compatibility,{' '}
        {CONTROLDText} ensures you can enjoy its features across all your preferred devices for a
        seamless browsing experience.
      </Paragraph>
    ),
  },
  {
    question: `How do I set up ${CONTROLDText} integrations on my devices?`,
    answer: (
      <Paragraph>
        Each integration follows a simple, step-by-step process that involves modifying your DNS
        settings to point to {CONTROLDText}&apos;s servers. By using clear tutorials and
        user-friendly instructions, you can quickly configure routers, operating systems, or apps.
        The platform also provides troubleshooting tips and FAQs to guide you along the way,
        ensuring an easy and efficient onboarding experience regardless of your technical expertise.
      </Paragraph>
    ),
  },
  {
    question: 'What if my integration stops working or I experience connection issues?',
    answer: (
      <Paragraph>
        If you notice your internet filtering isn&apos;t working as expected, start by verifying
        your DNS settings. Check that your device is configured to use {CONTROLDText}&apos;s servers
        and confirm your internet connection is stable. If problems persist, review the help center
        or reach out to {CONTROLDText}&apos;s support team. They can walk you through advanced
        troubleshooting steps, ensuring minimal downtime and a smooth user experience.
      </Paragraph>
    ),
  },
  {
    question: `Can I customize my filtering and DNS rules for different use cases?`,
    answer: (
      <Paragraph>
        Absolutely. {CONTROLDText} provides flexible filtering rules and customization options to
        suit diverse requirements—whether you&apos;re a parent seeking content controls or a
        business setting up specialized access. By defining custom blocklists, allowlists, or
        category-based filters, you can fine-tune your online experience.
      </Paragraph>
    ),
  },
]
